/**
 * 文字列を構成するコードポイントの個数を返却します。
 *
 * サロゲートペアなどを含まない文字列であれば str.length と同じ値になります。
 */
export const codePointCount = (str: string): number => {
  return Array.from(str).length;
};
